import {createContext} from 'react';


export const serviceContext = createContext(null);